import React, { Component } from 'react';
import _ from 'lodash';

export default class RevisionsEditForm extends Component{
	render(){
		const { modality } = this.props.match.params;
		let response = this._getAgencies();
		return(
			<div className="columns is-centered">
				<div className="column is-10">
					<table className="is-fullwidth table project-goal-table no-margin">
						<tbody>
						<tr>
							<td colSpan={3} className="goal-cell">
								<span className="help is-white">Instancia</span>
								<strong>{response ? response.agency.name:'---'}</strong>
							</td>
							<td colSpan={2} className="goal-cell">
								<span className="help is-white">{modality!=='modalidad-ii' ? 'Estado':'Municipio'}</span>
								<strong>{response ? response.agency.agenciable.name:'---'}</strong>
							</td>
						</tr>
						<tr>
							<td colSpan={2} style={{width:'25%'}}>
								<span className="help is-dark">Titular</span>
								<strong>{response  ? `${response.agency.owner.name} ${response.agency.owner.last_name} ${response.agency.owner.slast_name}`:'---'}</strong>
							</td>
							<td>
								<span className="help is-dark">Comentario</span>
								<strong>{response && !_.isEmpty(response.comments) ? response.comments:'Sin comentarios'}</strong>
							</td>
							<td style={{width:'20%'}}>
								{response && !_.isEmpty(response.project_version_phase_group) && !_.isEmpty(response.project_version_phase_group.revisions) ?
									_.map(response.project_version_phase_group.revisions, (rev, o) => {
										return [
											<span className="help is-dark" key={o}>{`Revisión ${rev.project_version_phase.version_phase.phase.name}`}</span>,
											<strong key={`status-${o}`}><span className="has-text-success">Revisado</span></strong>
										]
									})
									:<strong><span className="has-text-danger">No Revisado</span></strong>}
							</td>
							<td style={{width:'20%'}}>
								<span className="help is-dark">Tipo de notifiación</span>
								{this._renderNotificationType((response) ? response.notification_type : '')}
							</td>
						</tr>
						<tr>
							<td colSpan={5}>
								<span className="help is-dark">Proyecto</span>
								<strong>{response ? response.name:'---'}</strong>
							</td>
						</tr>
						</tbody>
					</table>
				</div>
			</div>
		);
	}

	_getAgencies(){
		let { list } = this.props.notification_messages;
		let { modality, state, municipality } = this.props.match.params;
		let { agencies } = this.props.session.user;
		let stateId = !_.isEmpty(agencies.states) ? _.find(agencies.states,{short: state}).id:undefined;
		let munId = municipality && !_.isEmpty(agencies.municipalities) ? _.find(agencies.municipalities,{slug:municipality}).id:undefined;
		let response = undefined;
		if(modality !=='modalidad-ii' && stateId && !_.isEmpty(list)){
			response = _.find(list,{agency:{agenciable:{id:stateId}}});
		}else if(modality ==='modalidad-ii' && stateId && munId && !_.isEmpty(list)){
			//return _.find(list,{state_id:stateId, municipality_id: munId});
			response = _.find(list,{agency:{municipality_id: munId, agenciable:{state_id:stateId}}});
		}else {
			response = undefined;
		}

		return response
	}

	_renderNotificationType(notification_type){
		if(notification_type === 'success') {
			return (<strong><span className="has-text-success">{notification_type}</span></strong>)
		}else if(notification_type === 'warning') {
			return (<strong><span className="has-text-warning">{notification_type}</span></strong>)
		}else if(notification_type === 'danger') {
			return (<strong><span className="has-text-danger">{notification_type}</span></strong>)
		}else {
			return ''
		}
	}
}


// WEBPACK FOOTER //
// ./src/elements/reports/revisions.jsx